






































































import Vue from "vue";
import EditNumber from "@/components/end_parts/EditNumber.vue";
import projParam from "@/template/parameter/proj_param.json";
import { JsonObject } from "types/opts-json";

export type PropItemType = {
  id: string;
  index: number;
};
export default Vue.extend({
  components: {
    EditNumber,
  },
  props: {
    //パラメータ
    selectionParam: {
      type: Object,
      default: Object,
    },
    //キー
    selectionKey: {
      type: String,
      default: String,
    },
    columnskey: {
      type: String,
      default: String,
    },
    selectionTransform: {
      type: String,
      default: String,
    },
    changeLanguage: {
      type: String,
      default: String,
    },
    selectionIndex: {
      type: Number,
      default: Number,
    },
    inputThirdHeader: {
      type: Number,
      default: Number,
    },
    selectionArray: {
      type: Array,
      default: Array,
    },
    disabledSelectbox: Boolean,
  },
  data() {
    return {
      selected: "",
      items: [] as { value: string; name: string }[],
      disable: false,
      selectedSwitch: true,
      ellpse: projParam.ellpse as { [key: string]: {} },
      error: "",
    };
  },
  watch: {
    selected() {
      if (this.selectionKey !== "columns") {
        this.selectionParam[this.selectionKey] = this.selected;
        if (this.selectionKey === "terr") {
          this.selectionParam.ellps = this.selected;
        }
      }
      if (this.selectionKey === "columns") {
        if (this.selected !== undefined) {
          this.ChangeColumns();
        }
      }
      if (this.selectionKey === "b_rf") {
        if (this.selected === "rf") {
          this.selectionParam.isRf = true;
        }
        if (this.selected === "b") {
          this.selectionParam.isRf = false;
        }
      }
    },
    selectionParam: {
      handler() {
        this.reload();
      },
      deep: true,
    },
    inputThirdHeader: {
      handler() {
        if (this.columnskey === "output") {
          if (this.inputThirdHeader === -1) {
            this.selectionParam[this.selectionKey] = [0, 1, -1];
            this.selected = String(
              this.selectionParam[this.selectionKey][this.selectionIndex]
            );
          } else {
            this.selectionParam[this.selectionKey] = [0, 1, 2];
            this.selected = String(
              this.selectionParam[this.selectionKey][this.selectionIndex]
            );
          }
        }
        this.reload();
      },
      deep: true,
    },
    selectionTransform: {
      handler() {
        if (this.columnskey === "output") {
          this.ChangeColumns();
        }
      },
      deep: true,
    },
    disabledSelectbox() {
      if (this.selectionKey === "kei") {
        this.disable = this.disabledSelectbox;
      }
    },
    selectionArray() {
      this.reload();
    },
    changeLanguage() {
      this.reload();
      if (this.columnskey === "output") {
        this.ChangeColumns();
      }
    },
  },
  created() {
    if (this.$store.state.inputFile.name !== undefined) {
      this.selectedSwitch = false;
    }
    if (this.selectionKey !== "columns") {
      if (this.selectionParam.isRf === true) {
        this.selected = "rf";
      }
      if (this.selectionParam.isRf === false) {
        this.selected = "b";
      }
      this.reload();
    }
    if (this.selectionKey === "columns") {
      this.reload();
      if (
        this.selectionParam[this.selectionKey][this.selectionIndex] !==
        undefined
      ) {
        this.selected = String(
          this.selectionParam[this.selectionKey][this.selectionIndex]
        );
      } else {
        this.selected = "-1";
      }
    }
  },
  methods: {
    reload() {
      if (this.selectionKey !== "columns") {
        this.items = [];
        //セレクトボックスの初期表示の設定
        if (this.selectionKey !== "b_rf") {
          this.selected = this.selectionParam[this.selectionKey];
        }
        //jsonファイルのitemlistからオブジェクトの作成
        let itemlist = Vue.i18n.translate(
          "opts." + this.selectionKey + ".item_list"
        );
        itemlist = String(itemlist);
        const keys: string[] = itemlist.split(",");
        keys.forEach((k) => {
          //item_listを「,」で分けているためやむを得ず
          if (k === "(comma)") {
            k = ",";
          }
          this.items.push({
            value: k,
            name: String(
              Vue.i18n.translate("opts." + this.selectionKey + ".items." + k)
            ),
          });
        });
      }
      if (this.selectionKey === "columns") {
        if (this.columnskey === "output") {
          this.items = [];
          // セレクトボックスの初期表示の設定
          // this.selected = this.selectionParam[this.selectionKey];
          //jsonファイルのitemlistからオブジェクトの作成
          let itemlist = Vue.i18n.translate(
            "opts." +
              this.selectionKey +
              "." +
              this.selectionIndex +
              "." +
              this.selectionTransform +
              ".item_list"
          );
          itemlist = String(itemlist);
          const keys: string[] = itemlist.split(",");
          keys.forEach((k) => {
            //item_listを「,」で分けているためやむを得ず
            if (k === "(comma)") {
              k = ",";
            }
            this.items.push({
              value: k,
              name: String(
                Vue.i18n.translate(
                  "opts." +
                    this.selectionKey +
                    "." +
                    this.selectionIndex +
                    "." +
                    this.selectionTransform +
                    ".items." +
                    k
                )
              ),
            });
          });
          if (this.inputThirdHeader === -1) {
            this.items.splice(2, 1);
          }
        }
        if (this.columnskey === "input") {
          this.items = [];
          if (
            this.selectionParam[this.selectionKey][this.selectionIndex] !==
            undefined
          ) {
            this.selected = this.selectionParam[this.selectionKey][
              this.selectionIndex
            ];
          } else {
            this.selected = "-1";
          }
          // セレクトボックスの初期表示の設定
          // this.selected = this.selectionParam[this.selectionKey];
          //jsonファイルのitemlistからオブジェクトの作成
          for (let k = 0; k < this.selectionArray.length; k++) {
            this.items.push({
              value: String(k),
              name: String(this.selectionArray[k]),
            });
          }
          if (this.selectionIndex === 2) {
            this.items.push({
              value: "-1",
              name: String(Vue.i18n.translate("opts.control.hidden")),
            });
          }
        }
      }
    },
    ChangeColumns() {
      if (this.selectionIndex === 0) {
        if (this.columnskey === "input") {
          if (this.selectionParam[this.selectionKey][2] === undefined) {
            this.selectionParam[this.selectionKey] = [
              Number(this.selected),
              this.selectionParam[this.selectionKey][1],
            ];
          } else {
            this.selectionParam[this.selectionKey] = [
              Number(this.selected),
              this.selectionParam[this.selectionKey][1],
              this.selectionParam[this.selectionKey][2],
            ];
          }
        }
        if (this.columnskey === "output") {
          if (this.selectedSwitch === true) {
            if (this.selectionParam[this.selectionKey][2] === undefined) {
              this.selectionParam[this.selectionKey] = [
                Number(this.selected),
                this.selectionParam[this.selectionKey][1],
              ];
              this.selectionParam["header_names"] = [
                Vue.i18n.translate(
                  "opts." +
                    this.selectionKey +
                    ".0." +
                    this.selectionTransform +
                    ".items." +
                    this.selected
                ),
                this.selectionParam["header_names"][1],
              ];
            } else {
              this.selectionParam[this.selectionKey] = [
                Number(this.selected),
                this.selectionParam[this.selectionKey][1],
                this.selectionParam[this.selectionKey][2],
              ];
              this.selectionParam["header_names"] = [
                Vue.i18n.translate(
                  "opts." +
                    this.selectionKey +
                    ".0." +
                    this.selectionTransform +
                    ".items." +
                    this.selected
                ),
                this.selectionParam["header_names"][1],
                this.selectionParam["header_names"][2],
              ];
            }
          }
        }
      }
      if (this.selectionIndex === 1) {
        if (this.columnskey === "input") {
          if (this.selectionParam[this.selectionKey][2] === undefined) {
            this.selectionParam[this.selectionKey] = [
              this.selectionParam[this.selectionKey][0],
              Number(this.selected),
            ];
          } else {
            this.selectionParam[this.selectionKey] = [
              this.selectionParam[this.selectionKey][0],
              Number(this.selected),
              this.selectionParam[this.selectionKey][2],
            ];
          }
        }
        if (this.columnskey === "output") {
          if (this.selectedSwitch === true) {
            if (this.selectionParam[this.selectionKey][2] === undefined) {
              this.selectionParam[this.selectionKey] = [
                this.selectionParam[this.selectionKey][0],
                Number(this.selected),
              ];
              this.selectionParam["header_names"] = [
                this.selectionParam["header_names"][0],
                Vue.i18n.translate(
                  "opts." +
                    this.selectionKey +
                    ".1." +
                    this.selectionTransform +
                    ".items." +
                    this.selected
                ),
              ];
            } else {
              this.selectionParam[this.selectionKey] = [
                this.selectionParam[this.selectionKey][0],
                Number(this.selected),
                this.selectionParam[this.selectionKey][2],
              ];
              this.selectionParam["header_names"] = [
                this.selectionParam["header_names"][0],
                Vue.i18n.translate(
                  "opts." +
                    this.selectionKey +
                    ".1." +
                    this.selectionTransform +
                    ".items." +
                    this.selected
                ),
                this.selectionParam["header_names"][2],
              ];
            }
          }
        }
      }
      if (this.selectionIndex === 2) {
        if (this.columnskey === "input") {
          if (this.selected === "-1") {
            this.selectionParam[this.selectionKey] = [
              this.selectionParam[this.selectionKey][0],
              this.selectionParam[this.selectionKey][1],
            ];
          } else {
            this.selectionParam[this.selectionKey] = [
              this.selectionParam[this.selectionKey][0],
              this.selectionParam[this.selectionKey][1],
              Number(this.selected),
            ];
          }
        }
        if (this.columnskey === "output") {
          if (this.selectedSwitch === true) {
            if (this.selected === "-1") {
              this.selectionParam[this.selectionKey] = [
                this.selectionParam[this.selectionKey][0],
                this.selectionParam[this.selectionKey][1],
              ];
              this.selectionParam["header_names"] = [
                this.selectionParam["header_names"][0],
                this.selectionParam["header_names"][1],
                "",
              ];
              return;
            }
            this.selectionParam[this.selectionKey] = [
              this.selectionParam[this.selectionKey][0],
              this.selectionParam[this.selectionKey][1],
              Number(this.selected),
            ];
            this.selectionParam["header_names"] = [
              this.selectionParam["header_names"][0],
              this.selectionParam["header_names"][1],
              Vue.i18n.translate(
                "opts." +
                  this.selectionKey +
                  ".2." +
                  this.selectionTransform +
                  ".items." +
                  this.selected
              ),
            ];
          }
        }
      }
      this.selectedSwitch = true;
    },
    changeTerr(event: Event) {
      const parameter = String(event);
      if (this.ellpse[parameter] === undefined) {
        this.error = "正しい測地系を入力してください";
        return;
      }
      this.error = "";
      this.selectionParam.ellps = parameter;
    },
  },
});
